import React from "react";
import { useTranslation } from "react-i18next";
import SystemSettings from "~/components/SystemSettings";
import Accordion from "~/components/utils/Accordion";

const SystemSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: `${t("systemSettings")}`,
          content: <SystemSettings />,
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default SystemSection;
